import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const FogIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M3 20.9663L5.9995 18.9756L9.02107 20.9792L12.0035 19.0004L15.0171 21L18.0145 19.0103L21 20.9921M3 17.9907L5.9995 16L9.02107 18.0036L12.0035 16.0248L15.0171 18.0244L18.0145 16.0347L21 18.0165'
                stroke='currentColor'
                strokeLinecap='round'
            />
        </>
    ),
})

FogIcon.displayName = 'FogIcon'
